import { useEffect, useState } from 'react';

import { IS_PREVIEW } from '../../constants';

function useWidgetPost() {
    const [showWidget, setShowWidget] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined' || !IS_PREVIEW) {
            return;
        }

        const params = new URLSearchParams(window.location.search);

        if (params.get('editor') === 'true' && IS_PREVIEW) {
            setShowWidget(true);

            return;
        }

        setShowWidget(false);
    }, []);

    return showWidget;
}

export default useWidgetPost;
